<template>
<div class="main">
    <p class="copied" v-if="alert">کپی شد</p>
    <div class="label-input" :dir="(ltr)?'ltr':'rtl'">
    <label class="label">{{label}}</label>
    <input class="input"  v-model="value" :disabled="disabled" @input="$emit('input')"/>
    <img  @click="copyLink()"  class='copy-icon' v-if="copy" src='../../assets/icon/copy.png' alt=""/>
  </div>
</div>
</template>

<script>
export default {
  name: "LabelInput.vue",
  components:{
  },
  props:{
    label:String,
    default:String,
    disabled:Boolean,
    copy:Boolean,
    ltr:Boolean
  },
  watch: {

    'value'(){
      this.$emit('value',this.value)
    }
  },
  data(){
    return{
      value:this.default,
      showDatePicker:false,
      alert:false
    }
  },
  methods:{
    copyLink(){
      navigator.clipboard.writeText(this.label)
      this.alert=true;
      setTimeout(()=>{this.alert=false;},3000)
    },
  }
}
</script>

<style scoped>
.main{
  display: flex;
  flex-direction: column;
  /* gap: 20px; */
  position: relative;
}
.copied{
  color: green;
  position: absolute;
  top: 40px;
  font-size: clamp(10px,1vw,12px);
}
.input{
  background: linear-gradient(180deg, #091222 0%, #0A1425 100%);
  box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.25);
  flex-grow: 1;
  font-size: clamp(12px,1.4vw,16px);
  color: white;
  width: 10px;
  padding: 0 8px ;

}

.copy-icon{
  cursor: pointer;
}

.label-input{
  border: 1px solid #D7C8C8;
  box-sizing: border-box;
  border-radius: 4px;
  max-height: 48px;
  min-height: 48px;
  flex-grow: 1;
  flex-basis: 100px;
  display: flex;
  justify-content: space-between;
  padding:4px  10px 4px 8px;
  align-items: center;
}

.label{
  color: #8C8585;
  font-size: clamp(12px,1.4vw,16px);
  background: linear-gradient(180deg, #091222 0%, #0A1425 100%);
  white-space: nowrap;
  box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.25);
}
</style>